import React from 'react';

/** @internal */
export var chevronSmallLeftThinIconElement = /*#__PURE__*/React.createElement("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  transform: "rotate(180)",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.35355 5.64645L4.35355 1.64645C4.15829 1.45118 3.84171 1.45118 3.64645 1.64645C3.45118 1.84171 3.45118 2.15829 3.64645 2.35355L7.29289 6L3.64645 9.64645C3.45118 9.84171 3.45118 10.1583 3.64645 10.3536C3.84171 10.5488 4.15829 10.5488 4.35355 10.3536L8.35355 6.35355C8.54882 6.15829 8.54882 5.84171 8.35355 5.64645Z"
}));